import { motion } from 'framer-motion';
import { Icon } from '../../Icons/Icon';
import { useModal } from '../../hooks/modalContext';

const SuccessfulEquifaxReporting = () => {
  const { setModal } = useModal();
  return (
    <motion.div
      className='relative w-[353px] max-h-[318px] bg-[#FFF] rounded-[12px] flex flex-col overflow-auto px-10 py-10 justify-center items-center'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Icon name='curlyCheck' className='text-success w-16 h-16 mb-4' />
      <span className='text-success text-[24px] font-semibold'>Awesome!</span>
      <span className='text-main text-base text-center mt-2 mb-6'>
        Reporting for your property has been enabled successfully.
      </span>
      <button
        className='submitBtn w-full'
        onClick={() => {
          setModal(null);
        }}
      >
        Close
      </button>
    </motion.div>
  );
};

export { SuccessfulEquifaxReporting };
